export enum Resource {
  user = 'user',
  file = 'file',
  report = 'report',
  campaignRequest = 'campaignRequest',
  campaignEditRequest = 'campaignEditRequest',
  campaignRequestComment = 'campaignRequestComment',
  organization = 'organization',
  organizationUser = 'organizationUser',
  organizationTeam = 'organizationTeam',
  organizationUserInvitation = 'organizationUserInvitation',
  organizationUserApiKey = 'organizationUserApiKey',
  activityLog = 'activityLog',
  campaignRequestProgram = 'campaignRequestProgram',
}
